export default "/dist/files/rubrique_reglement.38fd38912ec3f797aad0cb0f44852f02.svg";